import React from "react";
import "../App.css";

export default function StaffTraining() {
  return (
    <div className="page-in-development" id="staff-training">
      <h4>This page is currently in development</h4>
    </div>
  );
}
